import { render, staticRenderFns } from "./OrganismPins.vue?vue&type=template&id=f22ee85a&scoped=true&"
import script from "./OrganismPins.vue?vue&type=script&lang=js&"
export * from "./OrganismPins.vue?vue&type=script&lang=js&"
import style0 from "./OrganismPins.vue?vue&type=style&index=0&id=f22ee85a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22ee85a",
  null
  
)

export default component.exports